<template>
  <ion-button
    v-bind="$attrs"
    :size="size"
    :color="buttonColor"
    :fill="fill"
    :expand="expand"
    :shape="shape"
    :disabled="disabled"
    :type="type"
    class="base-button"
    :class="[customStyle ? `base-button--${customStyle}` : '']"
    mode="ios"
    :slot="slot"
  >
    <!-- Slot for icon at start -->
    <slot name="start" />

    <!-- Default slot for button content -->
    <slot />

    <!-- Slot for icon at end -->
    <slot name="end" />
  </ion-button>
</template>

<script setup>
import { computed } from 'vue'
import { IonButton } from '@ionic/vue'

const props = defineProps({
  size: {
    type: String,
    default: 'default',
    validator: (value) => ['small', 'default', 'large'].includes(value)
  },
  color: {
    type: String,
  },
  fill: {
    type: String,
    default: 'solid',
    validator: (value) => ['solid', 'outline', 'clear'].includes(value)
  },
  expand: {
    type: String,
    default: undefined,
    validator: (value) => ['block', 'full'].includes(value)
  },
  shape: {
    type: String,
    default: undefined,
    validator: (value) => ['round'].includes(value)
  },
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'button',
    validator: (value) => ['button', 'submit', 'reset'].includes(value)
  },
  customStyle: {
    type: String,
    default: '',
    validator: (value) => ['', 'outlineLight'].includes(value)
  },
  slot: {
    type: String,
    default: ''
  },
})

// Default icons for each type
const customStylesColors = {
  outlineLight: 'white',
}

const buttonColor = computed(() => {
  return props.color || customStylesColors[props.customStyle] || 'primary';
})
</script>

<style scoped>
/* Custom styling for all app buttons */
.base-button::part(native){
  --border-radius: 6px;
  font-size: 14px;
}

.base-button.button-default {
  min-height: 40px;
}

.base-button.button-round::part(native) {
  --padding-start: 20px;
  --padding-end: 20px;
  --border-radius: 44px;
}
</style>
